var map = {
	"./4006.jpg": "2168",
	"./adobeDesign.jpg": "ba68",
	"./adobeTwo.jpg": "86da",
	"./adobethree.jpg": "9f96",
	"./begin-in-coffeeMug.jpg": "030e",
	"./dashboard.png": "d480",
	"./facebook.png": "b576",
	"./image-1.jpg": "daa2",
	"./image-2.jpg": "42ce",
	"./image-3.jpg": "8681",
	"./instagram.png": "15a3",
	"./inventory-management.jpg": "493b",
	"./inventory.png": "025d",
	"./linkdin.png": "f12b",
	"./network.png": "f0b4",
	"./order-management.jpg": "b88d",
	"./pay-fail.jpg": "d92d",
	"./payment.png": "d68a",
	"./return.png": "ef43",
	"./sales.png": "6f03",
	"./salesman.png": "380d",
	"./twitter.png": "fa81",
	"./up-arrows.png": "4f9d",
	"./warehouse-management.jpg": "f783",
	"./warehouse.jpg": "68e9",
	"./white-walls.jpg": "7e0d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8d04";